import { render } from "./Assembly.vue?vue&type=template&id=00f8a9c0&scoped=true"
import script from "./Assembly.vue?vue&type=script&lang=js"
export * from "./Assembly.vue?vue&type=script&lang=js"

import "./Assembly.vue?vue&type=style&index=0&id=00f8a9c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00f8a9c0"

export default script